module.exports = __webpack_public_path__ + "media/images/profileicon-144194bb.png";